import { createIpaPlatform } from '@services/youtube-platform.service';
import { useEffect, useState } from 'react';
import SandboxV1 from '@components/Sandbox/v1';
import { useCookieListener } from '@lib/hooks/useCookie';
import { useTeamsData } from '@lib/hooks/useTeamsData';

export default function SandboxV1Page({
  platform,
  interaction
}) {
  const [platformId, setPlatformId] = useState(null);
  const { teamContext, initTeam } = useTeamsData((s) => ({ teamContext: s.teamContext, initTeam: s.initTeam }));
  const isLoggedIn = useCookieListener('IS_LOGGED_IN', 2000);

  useEffect(() => {
    initTeam();
  }, []);

  const findOrCreateSandboxPlatform = async () => {
    const res = await createIpaPlatform({ userId: teamContext?.oid });
    setPlatformId(res.entity[0].platform_id);
  };

  useEffect(() => {
    if (teamContext?.oid) {
      findOrCreateSandboxPlatform();
    }
  }, [teamContext]);

  if (!platformId) return null;

  return <SandboxV1
    isGuest={!isLoggedIn}
    platform={platform}
    platformId={platformId}
    interaction={interaction}
  />;
}

export const getServerSideProps = async ({ query }) => {
  const { platform = 'zoom', interaction = 'slide-first' } = query;

  return {
    props: {
      platform,
      interaction
    }
  };
};
